import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OAAPIConstant } from '../constants/oa.constant';
import { AppConfigService } from './base/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class OAService {
  apiBaseUrl = `${AppConfigService.settings.apiUrl}`;
  
  private completeApprovalResponse: any = null;
  getCurrentFacilityId(): string {
    return localStorage.getItem('current_facility_id') || 'ES';
  }
  constructor(private http: HttpClient) {
  }
  
  
  getAllData() {
    const facilityId = this.getCurrentFacilityId();

    return (
      this.http.get<any>(`${this.apiBaseUrl}${OAAPIConstant.getAll}?facilityId=${facilityId}`) )
  }

  getRightData() {
    const facilityId = this.getCurrentFacilityId();
    return (
      this.http.get<any>(`${this.apiBaseUrl}${OAAPIConstant.getByCAI}?facilityId=${facilityId}`) )
  }

  getWorkOrderList( workOrderList : any){
    const facilityId = this.getCurrentFacilityId();

    return (
      this.http.get<any>(`${this.apiBaseUrl}${OAAPIConstant.getWorkOrderList}?facilityId=${facilityId}&workOrderNo=${workOrderList}`) )
  }

  getTagDetails(tagNumber: string) {
    const facilityId = this.getCurrentFacilityId();

    return this.http.get<any>(`${this.apiBaseUrl}${OAAPIConstant.getTagDetails}?facility=${facilityId}&tagNumber=${tagNumber}`); ;
  }

  saveOA(data: any) {
    const facilityId = this.getCurrentFacilityId();
    return this.http.post<any>(`${this.apiBaseUrl}${OAAPIConstant.saveOA}?facility=${facilityId}`, data);
  }

  updateOA(data: any) {
    const facilityId = this.getCurrentFacilityId();
    return this.http.put<any>(`${this.apiBaseUrl}${OAAPIConstant.updateOA}?facility=${facilityId}`, data);
  }

  
}

